import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/assets";

const COLS = [
  {
    title: "Platform",
    links: [
      ["About Us", "/about-us"],
      ["Check Before You Trust", "/check-before-you-trust"],
      ["File a Complaint", "/file-a-complaint"],
      ["Resolve a Dispute", "/resolve-a-dispute"],
      ["Reviews & Feedback", "/reviews"],
      ["Vendor Directory", "/vendors"],
      ["Featured Vendors", "/featured-vendors"],
      ["Verified Profiles", "/verified-profiles"],
    ],
  },
  {
    title: "Resources",
    links: [
      ["Government Help", "/government-help"],
      ["Find a Lawyer", "/lawyers"],
      ["Blog", "/blog"],
      ["Frequently Asked Questions", "/faq"],
      ["Contact Us", "/contact"],
    ],
  },
  {
    title: "Business",
    links: [
      ["Vendor Registration", "/vendors/list-your-business"],
      ["Pricing", "/pricing"],
      ["Featured Listings", "/featured-vendors"],
      ["Advertising Enquiries", "/contact"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["Terms of Service", "/terms-of-service"],
      ["Privacy Policy", "/privacy-policy"],
      ["Complaint Policy", "/complaint-policy"],
      ["Evidence Policy", "/evidence-policy"],
      ["Community Guidelines", "/community-guidelines"],
      ["Moderation & Appeals", "/moderation-appeals"],
      ["Correction Request", "/correction-request"],
      ["Data Deletion Policy", "/data-deletion"],
      ["Disclaimer", "/disclaimer"],
      ["Accessibility Statement", "/accessibility"],
      ["Sitemap", "/sitemap"],
    ],
  },
];

const DISCLAIMER = "ComplaintAdvisor provides technology and information services for complaint documentation, communication, and dispute-support workflows. Content submitted by users may be incomplete, disputed, or subject to moderation. ComplaintAdvisor does not determine legal liability, guarantee recovery, or replace professional legal or government assistance.";

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-slate-300 mt-16">
      <div className="ca-container py-14">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <img src={LOGO_URL} alt="ComplaintAdvisor logo" className="h-9 w-9 rounded-lg bg-white object-contain" />
              <span className="font-display font-extrabold text-lg text-white">Complaint<span className="text-teal">Advisor</span></span>
            </div>
            <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
              Check Before You Trust. Resolve Before You Escalate. A neutral platform for documenting and communicating about customer and vendor disputes.
            </p>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="text-white font-semibold text-sm mb-3">{c.title}</h4>
              <ul className="space-y-2">
                {c.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-sm text-slate-400 hover:text-teal transition-colors">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 text-xs text-slate-400 leading-relaxed">
          <p className="mb-2">{DISCLAIMER}</p>
          <p>© {new Date().getFullYear()} ComplaintAdvisor.com — All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
